import { render, staticRenderFns } from "./MunicipalitiesINSEEList.vue?vue&type=template&id=201f44be&scoped=true&"
import script from "./MunicipalitiesINSEEList.vue?vue&type=script&lang=js&"
export * from "./MunicipalitiesINSEEList.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalitiesINSEEList.vue?vue&type=style&index=0&id=201f44be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f44be",
  null
  
)

export default component.exports